"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentFileType = void 0;
var AttachmentFileType;
(function (AttachmentFileType) {
    AttachmentFileType["PDF"] = "application/pdf";
    // Document types
    AttachmentFileType["TXT"] = "text/plain";
    AttachmentFileType["DOC"] = "application/msword";
    AttachmentFileType["DOCX"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    AttachmentFileType["RTF"] = "application/rtf";
    AttachmentFileType["ODT"] = "application/vnd.oasis.opendocument.text";
    // Spreadsheet types
    AttachmentFileType["XLS"] = "application/vnd.ms-excel";
    AttachmentFileType["XLSX"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    AttachmentFileType["ODS"] = "application/vnd.oasis.opendocument.spreadsheet";
    // Presentation types
    AttachmentFileType["PPT"] = "application/vnd.ms-powerpoint";
    AttachmentFileType["PPTX"] = "application/vnd.openxmlformats-officedocument.presentationml.presentation";
    AttachmentFileType["ODP"] = "application/vnd.oasis.opendocument.presentation";
    // Data formats
    AttachmentFileType["CSV"] = "text/csv";
    AttachmentFileType["JSON"] = "application/json";
    AttachmentFileType["XML"] = "application/xml";
    // Web formats
    AttachmentFileType["HTML"] = "text/html";
    AttachmentFileType["MARKDOWN"] = "text/markdown";
    // Image types
    AttachmentFileType["JPEG"] = "image/jpeg";
    AttachmentFileType["JPG"] = "image/jpeg";
    AttachmentFileType["PNG"] = "image/png";
    AttachmentFileType["GIF"] = "image/gif";
    AttachmentFileType["SVG"] = "image/svg+xml";
    AttachmentFileType["WEBP"] = "image/webp";
    AttachmentFileType["BMP"] = "image/bmp";
    AttachmentFileType["TIFF"] = "image/tiff";
    // Audio types
    AttachmentFileType["MP3"] = "audio/mpeg";
    AttachmentFileType["WAV"] = "audio/wav";
    AttachmentFileType["OGG"] = "audio/ogg";
    AttachmentFileType["AAC"] = "audio/aac";
    // Video types
    AttachmentFileType["MP4"] = "video/mp4";
    AttachmentFileType["WEBM"] = "video/webm";
    AttachmentFileType["AVI"] = "video/x-msvideo";
    AttachmentFileType["MOV"] = "video/quicktime";
    // Archive types
    AttachmentFileType["ZIP"] = "application/zip";
})(AttachmentFileType = exports.AttachmentFileType || (exports.AttachmentFileType = {}));
